import React from "react";
import * as S from "./styles";
import { useSettings } from "./useSettings";
import { LayoutTemplate } from "../LayoutTemplate";

export const SettingsTemplate = () => {
  const {
    navigate,
    canAccessStores,
    canAccessDealerships,
    canAccessHolidays,
    canAccessDeliveries,
    canAccessMobileUnits,
    canAccessEmployees,
    canAccessClients,
    canAccessProfiles,
    canAccessGoals,
  } = useSettings();

  return (
    <LayoutTemplate>
      <S.Container>
        <S.WrapperCards>
          {canAccessStores && (
            <S.Card onClick={() => navigate("/configuracoes/lojas")}>
              <p>Lojas</p>
            </S.Card>
          )}
          {canAccessDealerships && (
            <S.Card onClick={() => navigate("/configuracoes/concessionarias")}>
              <p>Concessionárias</p>
            </S.Card>
          )}
          {canAccessHolidays && (
            <S.Card onClick={() => navigate("/configuracoes/feriados")}>
              <p>Feriados</p>
            </S.Card>
          )}
          {canAccessDeliveries && (
            <S.Card onClick={() => navigate("/configuracoes/deliverys")}>
              <p>Delivery</p>
            </S.Card>
          )}
          {canAccessMobileUnits && (
            <S.Card onClick={() => navigate("/configuracoes/itinerantes")}>
              <p>Itinerantes</p>
            </S.Card>
          )}
          {canAccessEmployees && (
            <S.Card onClick={() => navigate("/configuracoes/colaboradores")}>
              <p>Colaboradores</p>
            </S.Card>
          )}
          {canAccessClients && (
            <S.Card onClick={() => navigate("/configuracoes/clientes")}>
              <p>Clientes</p>
            </S.Card>
          )}
          {canAccessProfiles && (
            <S.Card onClick={() => navigate("/configuracoes/perfis")}>
              <p>Perfis</p>
            </S.Card>
          )}
          {canAccessGoals && (
            <S.Card onClick={() => navigate("/configuracoes/metas")}>
              <p>Metas</p>
            </S.Card>
          )}
        </S.WrapperCards>
      </S.Container>
    </LayoutTemplate>
  );
};
